import { render, staticRenderFns } from "./saving-indicator.vue?vue&type=template&id=782edc51&"
import script from "./saving-indicator.vue?vue&type=script&lang=js&"
export * from "./saving-indicator.vue?vue&type=script&lang=js&"
import style0 from "./saving-indicator.vue?vue&type=style&index=0&id=782edc51&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports